module.exports = __webpack_public_path__ + "static/dale-a1b49be181f536b933794d206105225a.png";